module.exports = __webpack_public_path__ + "videos/webpush-chrome-desktop.b37acef.mp4";